export const MODULE_NAME = 'reservationOverview';

export const MODE_PAST = 'past';
export const MODE_ACTIVE = 'active';
export const MODE_FUTURE = 'future';
